<template>
  <z-dialogo
    ref="dialogo"
    titulo="Escolha a variação"
    scrollable
    dividers
    no-padding
    largura="800px"
    altura="383px"
  >
    <template v-slot:prepend>
      <v-toolbar flat color="white">
        <v-text-field
          ref="busca"
          v-model="search"
          rounded
          outlined
          single-line
          dense
          label="Pesquisar"
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-toolbar>
    </template>

    <template v-slot:texto>
      <v-data-table
        disable-pagination
        disable-sort
        hide-default-footer
        :headers="headers"
        :items="variacoes"
        :search="search"
        :loading="carregando"
        fixed-header
        height="383px"
      >
        <template v-slot:item="{ item: variacao }">
          <tr @click="selecionar(variacao)" style="cursor: pointer">
            <td class="font-weight-bold">{{ variacao.descricao }}</td>
            <td>
              <v-chip 
                v-for="(valor, index) in variacao.valores"
                class="mr-2"
                x-small 
                color="grey lighten-2"
                :key="index"
                readonly
              >{{valor.descricao}}</v-chip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </template>

    <template v-slot:actions_left>
      <span class="text-subtitle-2">Produtos encontrados: {{ variacoes.length }}</span>
    </template>
    <template v-slot:actions_right>
      <v-btn color="primary" @click="fechar()">Fechar</v-btn>
    </template>
  </z-dialogo>
</template>

<script>
export default {
  name: "DialogoBuscarVariacao",

  data() {
    return {
      search: '',
      busca: {
        descricao: ''
      },
      headers: [
          { text: "Variação", value: "descricao", width: "250px", },
          { text: "Valores", value: "varicao.valores", sortable: false },
        ],
      carregando: false,
    };
  },

  computed: {
    variacoes() {
      return this.$store.state.listas.variacoes;
    },
  },

  methods: {
    abrir() {
      this.$refs.dialogo.abrir();
      this.setFocus("busca", 300);
    },

    fechar() {
      this.$refs.dialogo.fechar();
    },

    selecionar(variacao) {
      this.$emit("selecionar:variacao", variacao);
      this.fechar();
    },

    onBuscaFocus(event) {
      event.target.select();
    },

    limparBusca() {
      this.busca = "";
      this.produtos = [];
      // this.buscar();
    },
  },
};
</script>

<style scoped></style>
